import React, { useState, useEffect } from "react";
import { AgGridReact } from "ag-grid-react";
import Modal from "react-modal";
import jwt_decode from "jwt-decode";
import axios from "axios";
import * as XLSX from "xlsx";
import * as MdIcons from "react-icons/md";
import * as RiIcons from "react-icons/ri";
import * as IoIcons from "react-icons/io";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import { toast } from "react-toastify";
// import { Delete, Edit, Close } from "@mui/icons-material";

import "./LostLock.css";
import { TemplateBtn } from "../Utility/TemplateBtn";
import {
  FETCH_LOCKS_URL,
  REACT_APP_NODE_ENV,
  REACT_APP_PADLOCK_DEV,
  REACT_APP_PADLOCK_LIVE,
  REACT_APP_PADLOCK_UPLOAD_DEV,
  REACT_APP_PADLOCK_UPLOAD_LIVE,
  UPLOAD_LOCKS_DATA_URL,
} from "../../api/apiRoutes";

Modal.setAppElement("#root");

const baseURL =
  REACT_APP_NODE_ENV === "DEV" ? REACT_APP_PADLOCK_DEV : REACT_APP_PADLOCK_LIVE;

const uploadURL =
  REACT_APP_NODE_ENV === "DEV"
    ? REACT_APP_PADLOCK_UPLOAD_DEV
    : REACT_APP_PADLOCK_UPLOAD_LIVE;

export default function LostLock() {
  const [modifyModalIsOpen, setModifyModalIsOpen] = useState(false);
  const [modifiedEmail, setModifiedEmail] = useState("");
  const [tableData, setTableData] = useState([]);
  const [gridApi, setGridApi] = useState(null);
  const [gridColumnApi, setGridColumnApi] = useState(null);
  const [password, setPassword] = useState("");
  const [setLockIdValue, setLockId] = useState("");

  const showToastAlert = (msg, type = "error") => {
    if (type === "error") {
      toast.error(msg, {
        position: "top-center",
      });
    } else if (type === "success") {
      toast.success(msg, {
        position: "top-center",
      });
    }
  };

  const openEndDateDialog = (params) => {
    if (params) {
      // console.log("Lock Id", params);
      // setFormData(params);
      setLockId(params.data.lockId);
      setModifyModalIsOpen(true);
      // const endDate = moment(new Date(couponInfo.end_date));
      // setDtpEndDate(endDate);
      // // console.log("Seto",dtpEndDate);
      // // console.log("Setdb",endDate);
      // setSelectedCouponInfo(couponInfo);
      // setIsEndDateDialogOpen(true);
    } else {
      // toast.warn("Something went wrong!!! Please try after sometimes.");
    }
  };
  const handleEndDateDialogUpdateBtnClick = async () => {
    try {
      // console.log(isNaN(Number(password)), "Type password");
      var passLength = password.length;
      if (isNaN(Number(password)) === true || passLength !== 6) {
        showToastAlert("Please enter only 6 digits number.");
        setPassword("");
      } else {
        var token = sessionStorage.getItem("token");
        const res = await axios({
          url: `/api/lock/updatePassword`,
          method: "post",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          data: { password: password, lockId: setLockIdValue },
        });
        if (res.status == 200) {
          setModifyModalIsOpen(false);
          showToastAlert(res.data.msg, "success");
        } else {
          // console.error("/api/coupon/editexpiry :: Exception", res); //todo: remove after testing
          // throw "Invalid response.";
          showToastAlert("Could Not Update Password");
        }
        setPassword("");
      }
    } catch (error) {
      // console.error("/api/coupon/editexpiry :: Exception", error);
      // return toast.error("Server error. Please try after sometimes.");
    }
  };

  const getData = () => {
    var token = sessionStorage.getItem("token");
    var { id, companyId } = jwt_decode(token);

    const formData = {
      // id: id,
      companyId: companyId,
    };

    axios({
      url: baseURL,
      method: "POST",
      headers: {
        "Content-Type": "Application/json",
      },
      data: formData,
    })
      .then((response) => {
        const results = response.data.data.reverse();

        setTableData(results);
      })
      .catch((e) => console.error(e.message));
  };

  const columnDefs = [
    {
      headerName: "Lock ID",
      field: "lockId",
    },
    { headerName: "MAC address", field: "mac_address" },
    {
      headerName: "Status",
      field: "action",
      cellRendererFramework: (params) => {
        const { status } = params.data;

        return (
          <p style={{ color: status == "active" ? "black" : "black" }}>
            {status.toUpperCase()}
          </p>
        );
      },
    },
    { headerName: "Condition", field: "conditioon" },
    { headerName: "State", field: "state" },
    { headerName: "Location", field: "location" },
    // { headerName: "DC Type", field: "dcType" },
    {
      headerName: "Battery Status",
      field: "batteryStatus",
      cellRendererFramework: (params) => {
        const { batteryStatus } = params.data;

        return (
          <p
            style={{
              color: batteryStatus ? "green" : "grey",
            }}
          >
            {batteryStatus ? batteryStatus : "NA"}
          </p>
        );
      },
    },
    { headerName: "Purpose", field: "purpose" },
    // { headerName: "Created By", field: "userId" },
    {
      headerName: "Created on",
      field: "createdOn",
      cellRendererFramework: (params) => {
        const date = params.data.createdOn;
        if (!date) return "";
        return <button className="userCreatedBtn">{date}</button>;
      },
    },
    {
      headerName: "Updated on",
      field: "updatedOn",
      cellRendererFramework: (params) => {
        const date = params.data.updatedOn;
        if (!date) return "";
        return <button className="userCreatedBtn">{date}</button>;
      },
    },
    {
      headerName: "Password Update",
      field: "lockId",
      cellRendererFramework: (params) => (
        <>
          <button
            className="modal-edit btn"
            // onClick={() => {
            //   setModifyModalIsOpen(true);
            //   // console.log(params.data.lockId);
            //   handleUserModify(params.data);
            // }}
            onClick={() => openEndDateDialog(params)}
          >
            <MdIcons.MdEdit />
          </button>
        </>
      ),
    },
  ];

  const uploadLockFile = async (file) => {
    try {
      let formData = new FormData();
      formData.append("csv", file);
      const response = await axios.post(UPLOAD_LOCKS_DATA_URL, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${sessionStorage?.getItem("token")}`,
        },
      });

      // console.log("response: ", response.data);
      if (!response.data.isError) {
        showToastAlert(`${file.name} uploaded successfully`, "success");
        window.location.reload();
      }
    } catch (error) {
      console.error("Error Uploading locks:", error);
      const errorMessage =
        error.response?.data?.msg || "An unknown error occurred.";
      showToastAlert(`${errorMessage}`);
    }
  };

  const onChange = (e) => {
    let csvFile = e.target.files[0];
    const reader = new FileReader();

    if (csvFile.size > 0) {
      reader.onload = (evt) => {
        const bstr = evt.target.result;
        const wb = XLSX.read(bstr, { type: "binary" });
        const wsname = wb.SheetNames[0];
        const ws = wb.Sheets[wsname];
        const data = XLSX.utils.sheet_to_csv(ws, { header: 1 });

        uploadLockFile(csvFile);
      };

      reader.readAsBinaryString(csvFile);
    } else {
      alert(`${csvFile.name} file size is ${csvFile.size} which is empty`);
    }
  };

  const upload = () => {
    document.getElementById("selectCSV").click();
  };

  const uploadUserUpdateData = () => {
    const modifyFormData = {
      email: modifiedEmail,
    };

    // axios({
    //   url: updateUserURL,
    //   method: "POST",
    //   headers: {
    //     "Content-Type": "Application/json",
    //   },
    //   data: modifyFormData,
    // })
    //   .then((response) => {
    //     console.info(response);
    //   })
    //   .catch((e) => console.error(e.message));
  };
  const handleModifySubmit = (e) => {
    e.preventDefault();
    uploadUserUpdateData();
  };

  const handleUpdateUserModalClose = (e) => {
    e.preventDefault();

    setModifyModalIsOpen(false);
  };

  const onFilterTextChange = (e) => {};

  // API IMPLEMENTATION:: Fetching Locks
  const fetchLocks = async () => {
    try {
      // console.log("token: ");
      const response = await axios.post(
        FETCH_LOCKS_URL,
        {},
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${sessionStorage?.getItem("token")}`,
          },
        }
      );
      // console.log("response: ", response.data.data);
      if (response.data.data) {
        setTableData(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching companies:", error);
    }
  };
  useEffect(() => {
    fetchLocks();
  }, []);

  const csvTemplateLock = ["mac_address", "lockId"];

  return (
    <>
      <div className="lost-lock-topSection">
        <input
          type="text"
          id="lock-filter-box"
          placeholder="Search"
          onChange={(e) => onFilterTextChange(e)}
        />

        <div className="lockUpload-container">
          <button id="lock-plus" onClick={upload}>
            Upload CSV
          </button>

          <input type="file" hidden id="selectCSV" onChange={onChange} />
        </div>

        <TemplateBtn data={csvTemplateLock} />
      </div>

      {/* Table */}
      <div
        className="ag-theme-alpine"
        style={{
          height: "100%",
          width: "99.9%",
          paddingLeft: "1px",
          borderLeft: "1px solid babfc7",
          borderRight: "1px solid babfc7",
        }}
      >
        {!tableData.length ? (
          <div className="data-blank-div">
            <h3 className="data-blank-h3">No data found to display!</h3>
          </div>
        ) : (
          <AgGridReact
            columnDefs={columnDefs}
            rowData={tableData}
            defaultColDef={{ resizable: true, flex: 1 }}
            pagination={true}
            paginationPageSize={25}
            domLayout="autoHeight"
          />
        )}
      </div>
      <Modal
        className="modify_modal"
        isOpen={modifyModalIsOpen}
        onRequestClose={() => setModifyModalIsOpen(false)}
      >
        <form className="userFormContainer" onSubmit={handleModifySubmit}>
          {/* <form className="userFormContainer"> */}
          <h2>
            <IoIcons.IoMdAlert /> Update Lock Password
          </h2>

          <label htmlFor="email">Lock ID</label>
          <input
            className="modalInput"
            type="number"
            name="email"
            // defaultValue={params.data.lockId}
            //value={formData.email}
            value={setLockIdValue}
            onChange={(e) => setLockId(e.target.value)}
          />
          <label htmlFor="password">Lock Password</label>
          <input
            className="modalInput"
            type="password"
            name="password"
            maxLength={6}
            // defaultValue={params.data.lockId}
            // value={formData.password}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <span style={{ display: "flex", justifyContent: "space-evenly" }}>
            {/* <input type="submit" value="Update" className="updateBtn" /> */}

            <button
              onClick={handleEndDateDialogUpdateBtnClick}
              className="modal-closeBtn"
            >
              Update
            </button>
            <button
              onClick={(e) => handleUpdateUserModalClose(e)}
              className="modal-closeBtn"
            >
              Cancel
            </button>
          </span>
        </form>
      </Modal>
    </>
  );
}
